import apiClient from '../index';

export const eventPhotosApi = {
  // Public event photos
  getPublicPhotos: (page = 1) => apiClient.get(`/event-photos/public?page=${page}`),

  // Mixed photo feed
  getMixedPhotos: (page = 1) => apiClient.get(`/mixed-photos?page=${page}`),

  // Get specific photo
  getPhotoById: (id) => apiClient.get(`/event-photos/${id}`),

  // Event photos listing
  getPhotos: (page = 1) => apiClient.get(`/event-photos?page=${page}`),

  // Mixed event photos
  getEventsMixedPhotos: (page = 1) => apiClient.get(`/events-mixed-photos?page=${page}`),

  // Public event photos by event
  getPublicPhotosByEvent: (id, page = 1) => apiClient.get(`/event-photos-public/${id}?page=${page}`),

  // Upload event photo
  uploadPhotos: (formData) => apiClient.post('/event-photos/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),

  // Delete event photo
  deletePhoto: (id) => apiClient.delete(`/event-photos/${id}`)
};

export default eventPhotosApi;
